import { FC, useEffect } from 'react';

import { noop } from '@adsk/alloy-react-helpers';
import { useLocale } from '@adsk/alloy-react-locale';

import { setLocale } from '../utils/i18n';

const ACCLocaleSubscriber: FC = () => {
  const { locale } = useLocale(noop);
  useEffect(() => {
    if (locale) {
      setLocale(locale);
    }
  }, [locale]);
  return null;
};

export default ACCLocaleSubscriber;
